<template>
    <a-modal width="80%" :visible="open" :maskClosable="false" :footer="false" :keyboard="false" @cancel="onClose">
        <a-divider orientation="left">换脸资源</a-divider>

        <!-- 操作按钮 -->
        <div class="table-operations" style="margin-bottom: 20px;">
            <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['video:gather:remove']"
                style="margin-right: 10px;">
                <a-icon type="delete" />删除
            </a-button>
            <a-button type="dashed" @click="$refs.createForm.handleAdd(id)">
                <a-icon type="import" />导入
            </a-button><!-- 公用标签设置 -->
            <div style="margin-bottom: 20px; display: flex; align-items: center; gap: 10px;">
                <span style="white-space: nowrap;">标签：</span>

                <a-select mode="multiple" style="min-width: 300px" placeholder="请选择标签" v-model="commonTagIds" allowClear
                    @dropdownVisibleChange="onTagDropdownChange">
                    <a-select-option v-for="tag in tagList" :key="tag.id" :value="tag.id">
                        {{ tag.tagTitle }}
                    </a-select-option>
                </a-select>
            </div>

        </div>

        <!-- 增加修改 -->
        <create-form ref="createForm" @ok="getList" />

        <!-- 列表展示 -->
        <div v-if="list.length === 0" style="text-align: center; margin: 20px 0">
            暂无数据
        </div>

        <div v-else class="list-container" style="display: flex; flex-wrap: wrap; gap: 20px;">
            <div v-for="(item, index) in list" :key="item.id"
                style="border: 1px solid #eee; padding: 10px; width: 220px;">
                <!-- 多选框 -->
                <a-checkbox :checked="item.checked" @change="selectOption({ ...item, checked: $event.target.checked })"
                    style="margin-bottom: 5px;">
                    <!-- {{ item.videoName || '未命名' }} -->
                </a-checkbox>

                <!-- <video v-if="item.videoUrl" :src="item.videoUrl" controls style="width: 100%; height: auto;"></video>


                <img v-if="item.imageUrl" :src="item.imageUrl" alt="剧集图片"
                    style="width: 100%; height: auto; margin-bottom: 10px;" /> -->

                <div style="font-size: 12px; color: #666; margin-bottom: 4px;">
                    ID：{{ item.id }}
                </div>

                <div class="media-container">
                    <video v-if="item.videoUrl" :src="item.videoUrl" controls class="media-content"></video>

                    <img v-if="item.imageUrl" :src="item.imageUrl" alt="剧集图片" class="media-content" />
                </div>

                <div style="margin-top: 5px; font-size: 12px; color: #999; text-align: center;">
                    {{ item.createTime }}
                </div>
                <div class="review-status">
                    视频审核状态：
                    <span v-if="item.reviewStatus === 0" class="status success">已通过</span>
                    <span v-else-if="item.reviewStatus === 1" class="status fail">审核失败</span>
                    <span v-else-if="item.reviewStatus === 2" class="status pending">审核中</span>
                </div>
                <a-form-model-item label="使用次数" prop="useNumber">
                    <a-input v-model="item.useNumber" placeholder="请输入使用次数" @blur="updateUseNumber(item)" />

                </a-form-model-item>

                <div style="text-align: center; margin-top: 8px;">
                    <a-button type="primary" size="small" :danger="item.status === 0" @click="updateFaceSwap(item)">
                        {{ item.status === 0 ? '禁用' : '启用' }}
                    </a-button>
                </div>
            </div>
        </div>
    </a-modal>
</template>

<script>
import { faceSwapList, delFaceSwap, updateFaceSwap, updateFaceSwapTag } from "@/api/video/video";
import { listTag } from "@/api/video/faceMaterialTag";
import CreateForm from "./modules/CreateForm";

export default {
    name: "FaceSwap",
    components: {
        CreateForm,
    },
    data() {
        return {
            list: [],
            open: false,
            id: "",
            selectedRowKeys: [],
            selectedRows: [],
            ids: [],
            multiple: true,
            queryParam: { videoId: null, tagIds: [] },
            tagList: [],
            commonTagIds: [],
            tagDropdownVisible: false
        };
    },
    methods: {
        onTagDropdownChange(visible) {
            if (!visible) {
                this.updateCommonTags();
            }
        },

        updateCommonTags() {
            if (!this.commonTagIds || !this.commonTagIds.length) {
                // 清空标签也允许的话，可以删掉这个判断
                return;
            }

            // ⭐ 数组 → 逗号字符串
            const tagIdsStr = this.commonTagIds.join(",");

            this.$confirm({
                title: "确认统一设置标签？",
                content: "将对当前换脸资源统一设置标签",
                onOk: () => {
                    return updateFaceSwapTag({
                        videoId: this.id,   // 或 ids，看你后端怎么批量
                        tagIds: tagIdsStr   // ⭐ 关键
                    }).then(res => {
                        if (res.success) {
                            this.$message.success("标签设置成功");

                            // 同步前端展示（可选）
                            this.list = this.list.map(item => ({
                                ...item,
                                tagIds: this.commonTagIds
                            }));
                        } else {
                            this.$message.error(res.message || "标签设置失败");
                        }
                    });
                }
            });
        },
        // 在 methods 中添加
        updateTags(item) {
            // 假设 updateFaceSwap 接口能够接收 tagIds 数组
            const tagIds = item.tagIds || [];

            // 静默提交
            updateFaceSwap({ id: item.id, tagIds: tagIds }).then((res) => {
                if (res.success) {
                    this.$message.success("标签更新成功");
                    // 不需要刷新整个列表，因为标签已在 item.tagIds 中更新
                } else {
                    this.$message.error(res.message || "标签更新失败");
                }
            }).catch(() => {
                this.$message.error("网络请求失败");
            });
        },
        async getTagList() {
            try {
                const response = await listTag(); // 假设 listTag 不需要参数
                if (response.success && response.data) {
                    // 假设后端返回的是一个包含标签对象的数组
                    this.tagList = response.data;
                } else {
                    this.$message.error(response.message || '标签列表加载失败');
                }
            } catch (e) {
                this.$message.error('请求标签列表出错');
            }
        },
        // 在 methods 中添加
        updateUseNumber(item) {
            clearTimeout(item._useTimer); // 使用不同的定时器名称
            item._useTimer = setTimeout(() => {
                const value = item.useNumber;

                // 验证逻辑 (可选)
                if (value == null || value < 0) {
                    this.$message.warning("请输入有效的使用次数");
                    return;
                }

                this.$confirm({
                    title: "确认修改使用次数？",
                    content: `确定将使用次数修改为 ${value} 吗？`,
                    onOk: () => {
                        return updateFaceSwap({ id: item.id, useNumber: value }).then((res) => {
                            if (res.success) {
                                this.$message.success("使用次数更新成功");
                                this.getList(); // 刷新数据
                            } else {
                                this.$message.error(res.message || "使用次数更新失败");
                            }
                        });
                    },
                });
            }, 300);
        },
        updateFaceSwap(item) {
            const newStatus = item.status === 0 ? 1 : 0; // 0启用 -> 1禁用，1禁用 -> 0启用
            const actionText = newStatus === 0 ? "启用" : "禁用";

            this.$confirm({
                title: `确认${actionText}该资源？`,
                content: `确定要${actionText}该换脸资源吗？`,
                onOk: () => {
                    return updateFaceSwap({ id: item.id, status: newStatus }).then((res) => {
                        if (res.success) {
                            this.$message.success(`${actionText}成功`);
                            this.getList();
                        } else {
                            this.$message.error(res.message || `${actionText}失败`);
                        }
                    });
                },
            });
        },
        getLists(value) {
            this.resetSelection();
            this.id = value;
            this.queryParam.videoId = value;
            this.queryParam.tagIds = [];
            this.open = true;

            Promise.all([
                faceSwapList(this.queryParam),
                listTag()
            ]).then(([faceRes, tagRes]) => {
                if (!faceRes.success || !tagRes.success) return;

                this.tagList = tagRes.data || [];

                const data = faceRes.data || [];

                this.list = data.map(item => ({
                    ...item,
                    checked: false,
                    tagIds: item.tagIds || []
                }));
                // ⭐ 回显公共标签（字符串 → 数组）
                this.$nextTick(() => {
                    const raw = data[0]?.tagIds;
                    this.commonTagIds = raw
                        ? raw.split(',')
                        : [];
                });
            });
        },

        getList() {
            this.queryParam.videoId = this.id;

            faceSwapList(this.queryParam).then((response) => {
                if (response.success) {
                    this.list = response.data.map((item) => ({ ...item, checked: false, tagIds: item.tagIds || [] }));
                }
            });
        },
        selectOption(e) {
            if (e.checked) {
                const findIndex = this.list.findIndex((i) => i.id === e.id);
                if (findIndex !== -1) this.$set(this.list, findIndex, { ...e });

                if (!this.ids.includes(e.id)) {
                    this.ids.push(e.id);
                    this.selectedRowKeys.push(e.id);
                    this.selectedRows.push(e);
                }
            } else {
                const findIndex = this.list.findIndex((i) => i.id === e.id);
                if (findIndex !== -1) this.$set(this.list, findIndex, { ...e });

                this.ids = this.ids.filter((id) => id !== e.id);
                this.selectedRowKeys = this.selectedRowKeys.filter((id) => id !== e.id);
                this.selectedRows = this.selectedRows.filter((item) => item.id !== e.id);
            }

            this.multiple = !this.selectedRowKeys.length;
        },
        resetSelection() {
            this.ids = [];
            this.selectedRowKeys = [];
            this.selectedRows = [];
            this.multiple = true;
            this.list.forEach((item, index) => {
                this.$set(this.list, index, { ...item, checked: false });
            });
        },
        onClose() {
            this.open = false;
            this.list = [];
            this.id = "";
            this.resetSelection();
        },
        handleDelete() {
            if (!this.ids.length) return;

            this.$confirm({
                title: "确认删除所选中数据?",
                content: "确认删除所选中数据",
                onOk: () => {
                    const data = this.ids.map((id) => ({ id }));
                    return delFaceSwap(data).then(() => {
                        this.getList();
                        this.$message.success("删除成功");
                        this.resetSelection();
                    });
                },
            });
        },
    },
};
</script>
<style scoped>
/* 媒体容器：移除 flex 布局，让内容自然垂直堆叠 */
.media-container {
    width: 100%;
    /* 移除 height: 300px; 或任何影响垂直堆叠的 flex 属性 */
    margin-bottom: 10px;
}

.media-content {
    /* 🌟 修正点：让每个媒体元素占据 100% 宽度 */
    width: 100%;

    /* 🌟 固定高度：这是实现对齐的关键。
       注意：如果同时有视频和图片，它们会都尝试占据这个高度。
       如果一个 item 中只会出现 videoUrl 或 imageUrl 其中之一，此方法可行。
    */
    height: 180px;
    /* 示例：您可以调整这个固定高度 */

    /* 确保内容不被拉伸，而是裁剪或留白 */
    object-fit: cover;
    /* 如果希望内容填满并裁剪 */
    /* object-fit: contain; /* 如果希望内容完整显示并留白 */

    /* 确保图片/视频垂直堆叠 */
    display: block;
}

/* 确保 video 元素和 img 元素之间有间隔（如果需要） */
.media-content+.media-content {
    margin-top: 5px;
}

.review-status {
    margin-top: 6px;
}

.status {
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
}

.status.success {
    background: #f6ffed;
    color: #52c41a;
    border: 1px solid #b7eb8f;
}

.status.fail {
    background: #fff1f0;
    color: #ff4d4f;
    border: 1px solid #ffa39e;
}

.status.pending {
    background: #fffbe6;
    color: #faad14;
    border: 1px solid #ffe58f;
}
</style>